import { Shield } from "lucide-react";
import { Link } from "react-router-dom";

interface FooterProps {
  /** Use compact variant for dashboard pages */
  variant?: "full" | "compact";
}

export function Footer({ variant = "full" }: FooterProps) {
  const isCompact = variant === "compact";

  return (
    <footer className={`bg-slate-900 text-slate-400 ${isCompact ? 'py-6' : 'py-12'} px-4 sm:px-6 lg:px-8`}>
      <div className="max-w-7xl mx-auto">
        {!isCompact && (
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary-500 to-success-500 flex items-center justify-center">
                  <Shield className="w-6 h-6 text-white" />
                </div>
                <span className="text-xl font-bold text-white">ZKCN</span>
              </div>
              <p className="text-sm">
                Privacy-preserving verification infrastructure for any credential type.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-4">Product</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="/#features" className="hover:text-white transition-colors">Features</a></li>
                <li><a href="/#credentials" className="hover:text-white transition-colors">Credentials</a></li>
                <li><Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link></li>
                <li><Link to="/docs" className="hover:text-white transition-colors">API Docs</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-4">Company</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
                <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
                <li><Link to="/careers" className="hover:text-white transition-colors">Careers</Link></li>
                <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-4">Legal</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
                <li><Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
                <li><Link to="/security" className="hover:text-white transition-colors">Security</Link></li>
                <li><Link to="/compliance" className="hover:text-white transition-colors">Compliance</Link></li>
              </ul>
            </div>
          </div>
        )}

        <div className={`${!isCompact ? 'mt-12 pt-8 border-t border-slate-800' : ''} flex flex-col sm:flex-row justify-between items-center gap-4`}>
          <p className="text-sm">© 2026 ZKCN. All rights reserved.</p>
          <div className="flex items-center gap-2 text-sm">
            <span>Deployed on</span>
            <span className="px-2 py-1 bg-slate-800 rounded text-xs font-mono">Base</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
